import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnDate,
  columnNameLink,
  columnRowCount,
  columnStatus,
  columnTools,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';

const DictionaryReportsTableColumns = ({ columns }) => (
  <>
    <Table.Row>
      {hasColumn(columns, columnNameLink) && (<UnsortedColumn columnId={columnNameLink} />)}
      {hasColumn(columns, columnDate) && (<UnsortedColumn columnId={columnDate} />)}
      {hasColumn(columns, columnStatus) && (<UnsortedColumn columnId={columnStatus} />)}
      {hasColumn(columns, columnRowCount) && (<UnsortedColumn textAlign="right" columnId={columnRowCount} />)}
      {hasColumn(columns, columnTools) && (<UnsortedColumn />)}
    </Table.Row>
  </>
);

export default DictionaryReportsTableColumns;
